module.exports = __webpack_public_path__ + "img/home-19.d5123baf.png";